import { IconLayer as DeckIconLayer } from '@deck.gl/layers';

class IconLayer extends DeckIconLayer {
  static layerName = 'IconLayer';
  initializeState() {
    super.initializeState();
    // @ts-ignore
    this.state.iconManager._canvasWidth = 4000;
  }
}

export default IconLayer;
